<!--
 * @Descripttion: app
 * @version: 1.0.0
 * @Author: Jiang ShareFont
 * @Date: 2023-03-15 15:24:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-05-23 11:44:42
-->
<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'App'
}
</script>

<style>
* {
    margin: 0;
    padding: 0;
}

body {
    background: #f2f2f2;
    font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, PingFang SC,
        Microsoft YaHei, Source Han Sans SC, Noto Sans CJK SC,
        WenQuanYi Micro Hei, sans-serif !important;
}

input,
textarea,
button,
select {
    outline: none;
    border: none;
}

img {
    content: normal !important;
}

.text-over-hidden {
    white-space: nowrap !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
}

/* vue */
[v-cloak] {
    display: none;
}

.flex {
    display: flex;
}
.justify-center {
    justify-content: center;
}
.justify-between {
    justify-content: space-between;
}
.justify-end {
    justify-content: flex-end;
}
.align-center {
    align-items: center;
}
.font-12 {
    font-size: 12px;
}
.font-14 {
    font-size: 14px;
}
.font-18 {
    font-size: 18px;
}
.font-20 {
    font-size: 20px;
}
.font-24 {
    font-size: 24px;
}
.font-30 {
    font-size: 30px;
}

.cell {
    padding: 0 20px !important;
}

#app, body, html {
    width: 100%;
    height: 100%;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin: 0 auto;
}

</style>



// WEBPACK FOOTER //
// src/App.vue